/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Loader } from '@g17eco/atoms/loader';
import { UtrModalBody } from './UtrModalBody';
import { closeUniversalTrackerModal, reloadHistory } from '../../actions/universalTrackerModal';
import './styles.scss';
import { AppDispatch, RootState } from '../../reducers';
import { FeaturePermissions } from '../../services/permissions/FeaturePermissions';
import UniversalTrackerModalService from '../../model/UniversalTrackerModalService';
import { canManageCurrentLevel, getCurrentUser } from '../../selectors/user';
import { getRootConfig } from '@selectors/globalData';
import { UtrvHistoryModalTemplate } from './UtrvHistoryModalTemplate';
import { SurveyType } from '@g17eco/types/surveyCommon';
import { DataPeriods } from '@utils/dataPeriods';
import { Filters } from './SurveyFilters';
import { BasicAlert } from '@g17eco/molecules/alert';

class UTrModal extends Component<PropsFromRedux> {

  closeModal = () => {
    this.props.closeUniversalTrackerModal();
  };

  render() {
    const { universalTrackerModalState, canAccessCustomDashboards, reloadHistory, currentUser, canManage } = this.props;
    const { open, loadedOverview, errored, errorMessage, modalService } = universalTrackerModalState;
    if (!open) {
      return '';
    }

    // If there is an error, Container will handle that.
    if (!errored && !loadedOverview) {
      return <Loader />;
    }

    if (errored || !modalService) {
      return this.renderModal(
        <BasicAlert type={'danger'}>{errorMessage}</BasicAlert>
      );
    }

    const handleReloadUtrvs = async ({surveyType, period}: Filters) => {
      return reloadHistory(modalService, {
        surveyType: surveyType === 'all' ? undefined : surveyType,
        period: period === 'all' ? undefined : period,
      })
    }

    return this.renderModal(
      <UtrModalBody
        modalService={modalService}
        alternativeCode={universalTrackerModalState.alternativeCode}
        canAccessCustomDashboards={canAccessCustomDashboards}
        hideProvenance={universalTrackerModalState.hideProvenance}
        reloadUtrvs={handleReloadUtrvs}
        currentUser={currentUser}
        activeTabId={universalTrackerModalState.activeTabId}
        canManage={canManage}
        initialFilters={{ surveyType: 'all', period: 'all' }}
        onChangeFilters={handleReloadUtrvs}
      />
    );
  }

  renderModal(body: JSX.Element) {
    return <UtrvHistoryModalTemplate toggle={this.closeModal}>{body}</UtrvHistoryModalTemplate>;
  }
}

const mapStateToProps = (state: RootState) => {
  const rootConfig = getRootConfig(state);
  return {
    universalTrackerModalState: state.universalTrackerModal,
    canAccessCustomDashboards: FeaturePermissions.canAccessCustomDashboards(rootConfig),
    currentUser: getCurrentUser(state),
    canManage: canManageCurrentLevel(state),
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    closeUniversalTrackerModal: () => {
      dispatch(closeUniversalTrackerModal());
    },
    reloadHistory: (
      modalService: UniversalTrackerModalService,
      filters: { surveyType?: SurveyType; period?: DataPeriods },
    ) => {
      dispatch(reloadHistory(modalService, filters));
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(UTrModal);
